import React, { useCallback, useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Table,
  Typography,
  RadioGroup,
  Radio,
  Form,
  Button,
  Divider,
} from "@douyinfe/semi-ui";
import { VChart } from "@visactor/react-vchart";
import {
  IconStackBarChartStroked,

} from "@douyinfe/semi-icons";
import { ApiClient } from "../../api/ApiClient";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import { generateMockData1 } from "./testData";

export default function OverallDashboard() {
  const [city, setCity] = useState('贵阳');
  const [statData, setStatData] = useState({} as any);
  const [loading, setLoading] = useState(false);
  const [allLeadStar, setAllLeadStar] = useState([] as any);
  const [allLeadType, setAllLeadType] = useState([] as any);
  const [allLeadStatus, setAllLeadStatus] = useState([] as any);
  const [allLeadTypeStar, setAllLeadTypeStar] = useState([] as any);
  const [allLeadTypeStatus, setAllLeadTypeStatus] = useState([] as any);
  const [poolLeadStar, setPoolLeadStar] = useState([] as any);
  const [poolLeadStatus, setPoolLeadStatus] = useState([] as any);
  const [loadingLeadTypeStar, setLoadingLoadingLeadTypeStar] =
    useState(false);
  const [loadingLeadTypeStatus, setLoadingLoadingLeadTypeStatus] =
    useState(false);
  let apiClient = ApiClient.getDefault();

  const { Title, Text } = Typography;
  useEffect(() => {

    queryAll();
  }, []);

  const queryAll = async () => {
    let data = {};
    queryAllLeadStar(data);
    queryAllLeadType(data);
    queryAllLeadStatus(data);
    queryAllLeadTypeStar(data);
    queryAllLeadTypeStatus(data);
    queryPoolLeadStar(data);
    queryPoolLeadStatus(data);
  };


  const queryAllLeadStar = async (data: any) => {
    // apiClient
    //   .request("/users/updateDailyCap", "GET", params)
    //   .then((resp) => {
    //     setLoadingDateNewLeadAmount(false);
    //     setDateNewLeadAmount(resp.data);
    //   });

    const dt = generateMockData1(1);
    setAllLeadStar(dt);
  };


  const queryAllLeadStatus = async (data: any) => {
    // apiClient
    //   .request("/users/updateDailyCap", "GET", params)
    //   .then((resp) => {
    //     setLoadingDateNewLeadAmount(false);
    //     setDateNewLeadAmount(resp.data);
    //   });

    const dt = generateMockData1(2);
    setAllLeadStatus(dt);
  };

  const queryAllLeadType = async (data: any) => {
    // apiClient
    //   .request("/users/updateDailyCap", "GET", params)
    //   .then((resp) => {
    //     setLoadingDateNewLeadAmount(false);
    //     setDateNewLeadAmount(resp.data);
    //   });

    const dt = generateMockData1(3);
    setAllLeadType(dt);
  };

  const queryAllLeadTypeStar = async (data: any) => {
    // apiClient
    //   .request("/users/updateDailyCap", "GET", params)
    //   .then((resp) => {
    //     setLoadingDateNewLeadAmount(false);
    //     setDateNewLeadAmount(resp.data);
    //   });

    const dt = generateMockData1(4);
    setAllLeadTypeStar(dt);
  };
  const queryAllLeadTypeStatus = async (data: any) => {
    // apiClient
    //   .request("/users/updateDailyCap", "GET", params)
    //   .then((resp) => {
    //     setLoadingDateNewLeadAmount(false);
    //     setDateNewLeadAmount(resp.data);
    //   });

    const dt = generateMockData1(5);
    setAllLeadTypeStatus(dt);
  };



  const queryPoolLeadStar = async (data: any) => {
    // apiClient
    //   .request("/users/updateDailyCap", "GET", params)
    //   .then((resp) => {
    // setDateLeadVisitStar(data);
    // setLoadingDateLeadVisitStar(false);
    //   });

    const dt = generateMockData1(6);
    setPoolLeadStar(dt);
  };
  const queryPoolLeadStatus = async (data: any) => {
    // apiClient
    //   .request("/users/updateDailyCap", "GET", params)
    //   .then((resp) => {
    // setDateLeadVisitStar(data);
    // setLoadingDateLeadVisitStar(false);
    //   });

    const dt = generateMockData1(7);
    setPoolLeadStatus(dt);
  };


  const commonPieSpec = (id: string, pieData: any) => {
    return {
      type: 'pie',
      data: [
        {
          id: id,
          values: pieData
        }
      ],
      valueField: 'value',
      categoryField: 'type',
      outerRadius: 0.8,
      innerRadius: 0.5,
      padAngle: 0.6,
      pie: {
        style: {
          cornerRadius: 10
        },
        state: {
          hover: {
            outerRadius: 0.85,
            stroke: '#000',
            lineWidth: 1
          },
          selected: {
            outerRadius: 0.85,
            stroke: '#000',
            lineWidth: 1
          }
        }
      },
      label: {
        visible: true
      },
      tooltip: {
        mark: {
          content: [
            {
              key: (datum: any) => datum['type'],
              value: (datum: any) => datum['value']
            }
          ]
        }
      },

      legends: {
        visible: true,
        orient: 'right'
      },
      indicator: {
        visible: true,
        trigger: 'select',
        title: {
          visible: true,
          style: {
            fontSize: 12,
            fontWeight: 'normal',
            text: (data: any) => {
              if (data) {
                const value = data['type'];
                return value ? value : null;
              }
              return '总和';
            }
          }
        },
        content: [
          {
            visible: true,
            fontWeight: 'bold',
            style: {
              fontSize: 20,
              // 修改为显式指定 data 参数的类型为 any
              text: (data: any) => {
                if (data) {
                  const value = data['value'];
                  return value ? `${value}%` : null;
                }
                return 1234;
              }
            }
          }
        ]
      }
    }
  }

  const leadStarPieSpec: any = commonPieSpec('leadStar', allLeadStar.chartData)
  const leadStatusPieSpec: any = commonPieSpec('leadStatus', allLeadStatus.chartData)
  const leadTypePieSpec: any = commonPieSpec('leadType', allLeadType.chartData)


  const leadTypeStatusSpec: any = {
    type: "bar",
    stack: true,
    data: {
      id: "barData",
      values: allLeadTypeStatus.chartData,
    },
    xField: "value",
    yField: "type",
    seriesField: "seriesValue",
    legends: { visible: true },
    tooltip: {
      dimension: {
        updateContent: (data: any[]) => {
          let sum = 0;
          data.forEach((datum) => {
            sum += +datum.value;
          });
          data.push({
            hasShape: "false",
            key: "总数",
            value: sum,
          });
          return data;
        },
      },
    },
    direction: "horizontal",
    label: {
      visible: true,
      position: "inside",
      offset: 2,
      overlap: false,
      style: {},
    },
  };

  const leadTypeStarSpec: any = {
    type: "bar",
    stack: true,
    data: {
      id: "barData",
      values: allLeadTypeStar.chartData,
    },
    xField: "value",
    yField: "type",
    seriesField: "seriesValue",
    legends: { visible: true },
    tooltip: {
      dimension: {
        updateContent: (data: any[]) => {
          let sum = 0;
          data.forEach((datum) => {
            sum += +datum.value;
          });
          data.push({
            hasShape: "false",
            key: "总数",
            value: sum,
          });
          return data;
        },
      },
    },
    direction: "horizontal",
    label: {
      visible: true,
      position: "inside",
      offset: 2,
      overlap: false,
      style: {},
    },
  };

  const colorScheme = {
    /** 默认渐进式色板 */
    default: [
      {
        maxDomainLength: 1,
        scheme: ["rgba(142, 212, 231, 1)"], // 适用于 1 个数据项的色板
      },
    ],
  };
  const poolLeadStarSpec = {
    type: "bar",
    data: [
      {
        id: "barKpi",
        values: poolLeadStar.chartData,
      },
    ],
    seriesField: "seriesValue",
    xField: "type",
    yField: "value",
    direction: "vertical",
    legends: {
      visible: true,
    },
    label: {
      visible: true,
      position: "inside",
      offset: 2,
      overlap: false,
      style: {},
    },
  };

  const poolLeadStatusSpec = {
    type: "bar",
    data: [
      {
        id: "barVisitKpi",
        values: poolLeadStatus.chartData,
      },
    ],
    theme: { colorScheme },
    seriesField: "seriesValue",
    xField: "type",
    yField: "value",
    direction: "vertical",
    legends: {
      visible: true,
    },
    label: {
      visible: true,
      position: "inside",
      offset: 2,
      overlap: false,
      style: {},
    },
  };


  const onChange = useCallback((e: any) => setCity(e.target.value), []);


  return (
    <>
      <RadioGroup onChange={onChange} value={city} type="button" >
        <Radio value={'贵阳'}>贵阳</Radio>
        <Radio value={'遵义'}>遵义</Radio>
      </RadioGroup>
      <div
        style={{ padding: 20, backgroundColor: "#f8f9fa", minHeight: "100vh" }}
      >
        {/* 顶部卡片 */}
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={4}>
            <Card bordered={false} shadows="hover" style={{ backgroundColor: 'rgba(var(--semi-light-blue-0), 1)' }}>
              <Text type="secondary">用户数</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalNew}
              </Title>
              <Text type="secondary">较昨日 +12%</Text>
            </Card>
          </Col>
          <Col span={4}>
            <Card bordered={false} shadows="hover" style={{ backgroundColor: 'rgba(var(--semi-light-blue-0), 1)' }}>
              <Text type="secondary">接单用户数</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalNew}
              </Title>
              <Text type="secondary">较昨日 +12%</Text>
            </Card>
          </Col>
          <Col span={4}>
            <Card bordered={false} shadows="hover" style={{ backgroundColor: 'rgba(var(--semi-light-blue-0), 1)' }}>
              <Text type="secondary">每日客户上线</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalNew}
              </Title>
              <Text type="secondary">较昨日 +12%</Text>
            </Card>
          </Col>
          <Col span={4}>
            <Card bordered={false} shadows="hover" >
              <Text type="secondary">我的客户数</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalNew}
              </Title>
              <Text type="secondary">较昨日 +12%</Text>
            </Card>
          </Col>
          <Col span={4}>
            <Card bordered={false} shadows="hover">
              <Text type="secondary">再分配客户数</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.avgFollowRate}
              </Title>
              <Text type="secondary">行业基准 65%</Text>
            </Card>
          </Col>
          <Col span={4}>
            <Card bordered={false} shadows="hover">
              <Text type="secondary">重要客户数</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalNew}
              </Title>
              <Text type="secondary">较昨日 +12%</Text>
            </Card>
          </Col>
        </Row>
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={4}>
            <Card bordered={false} shadows="hover">
              <Text type="secondary">公共池客户数</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalNew}
              </Title>
              <Text type="secondary">较昨日 +12%</Text>
            </Card>
          </Col>
          <Col span={4}>
            <Card bordered={false} shadows="hover" style={{ backgroundColor: 'rgba(var(--semi-red-0), 1)' }}>
              <Text type="secondary">0星客户数</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalVisits}
              </Title>
              <Text type="secondary">转化率 18%</Text>
            </Card>
          </Col>
          <Col span={4}>
            <Card bordered={false} shadows="hover" style={{ backgroundColor: 'rgba(var(--semi-red-0), 1)' }}>
              <Text type="secondary">1-2星客户数</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalVisits}
              </Title>
              <Text type="secondary">转化率 18%</Text>
            </Card>
          </Col>
          <Col span={4}>
            <Card bordered={false} shadows="hover" style={{ backgroundColor: 'rgba(var(--semi-red-0), 1)' }}>
              <Text type="secondary">3+星客户数</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalNew}
              </Title>
              <Text type="secondary">较昨日 +12%</Text>
            </Card>
          </Col>
          <Col span={4}>
            <Card bordered={false} shadows="hover" style={{ backgroundColor: 'rgba(var(--semi-lime-0), 1)' }}>
              <Text type="secondary">总上门量</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalVisits}
              </Title>
              <Text type="secondary">转化率 18%</Text>
            </Card>
          </Col>
          <Col span={4}>
            <Card bordered={false} shadows="hover" style={{ backgroundColor: 'rgba(var(--semi-lime-0), 1)' }}>
              <Text type="secondary">总签约量</Text>
              <Title heading={2} style={{ marginTop: 8 }}>
                {statData.totalVisits}
              </Title>
              <Text type="secondary">转化率 18%</Text>
            </Card>
          </Col>
        </Row>

        {/* 第一行：客户星级分布 */}
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={8}>
            <Card
              title="客户星级分布"
              headerExtraContent={
                <Text type="secondary">
                  0-5星客户数量和占比
                </Text>
              }

            >
              <VChart
                spec={leadStarPieSpec}
                options={{ mode: "desktop-browser" }}
                height={300}
              />

            </Card>
          </Col>

          <Col span={8}>
            <Card
              title="客户状态分布"
              headerExtraContent={
                <Text type="secondary">每日新增客户星级比例</Text>
              }
            >
              <VChart
                spec={leadStatusPieSpec}
                options={{ mode: "desktop-browser" }}
                height={300}
              />


            </Card>
          </Col>
          <Col span={8}>
            <Card
              title="客户类型分布"
              headerExtraContent={
                <Text type="secondary">每日新增客户星级比例</Text>
              }
            >
              <VChart
                spec={leadTypePieSpec}
                options={{ mode: "desktop-browser" }}
                height={300}
              />


            </Card>
          </Col>
        </Row>

        {/* 第二行：客户类型 */}
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={12}>
            <Card
              title="客户类型星级分布"
              headerExtraContent={
                <Text type="secondary">每日再分配客户跟进情况，跟进率</Text>
              }
            >


              <VChart
                spec={leadTypeStarSpec}
                options={{ mode: "desktop-browser" }}
                height={400}
              />


              <Table
                loading={loadingLeadTypeStar}
                columns={[
                  { title: "客户类型", dataIndex: "type" },
                  { title: "总数", dataIndex: "valueTotal" },
                  { title: "0星", dataIndex: "value0" },
                  { title: "1星", dataIndex: "value1" },
                  { title: "2星", dataIndex: "value2" },
                  { title: "3星", dataIndex: "value3" },
                  { title: "4星", dataIndex: "value4" },
                  { title: "5星", dataIndex: "value5" },
                ]}
                dataSource={allLeadTypeStar.tableData}
              />


            </Card>
          </Col>

          <Col span={12}>
            <Card
              title="客户类型状态分布"
              headerExtraContent={
                <Text type="secondary">每日上门 客户数，上门客户星级分布</Text>
              }
            >

              <VChart
                spec={leadTypeStatusSpec}
                options={{ mode: "desktop-browser" }}
                height={400}
              />

              <Table
                loading={loadingLeadTypeStatus}
                columns={[
                  { title: "客户状态", dataIndex: "type" },
                  { title: "总数", dataIndex: "valueTotal" },
                  { title: "未处理", dataIndex: "value0" },
                  { title: "待跟进", dataIndex: "value1" },
                  { title: "外地客户", dataIndex: "value2" },
                  { title: "待上门", dataIndex: "value3" },
                  { title: "已上门", dataIndex: "value4" },
                  { title: "已签约", dataIndex: "value5" },
                  { title: "已回款", dataIndex: "value5" },
                ]}
                dataSource={allLeadTypeStatus.tableData}
              />


            </Card>
          </Col>
        </Row>
        {/* 
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={12}>
            <Card
              title="公共池不同星级客户数"
              headerExtraContent={
                <Text type="secondary">按新客分配数来对销售进行排名</Text>
              }
            >
              <VChart
                key="sales-kpi"
                spec={poolLeadStarSpec}
                options={{ mode: "desktop-browser" }}
                height={300}
              />

            </Card>
          </Col>
          <Col span={12}>
            <Card
              title="公共池不同类型客户数"
              headerExtraContent={
                <Text type="secondary">按客户上门数来对销售进行排名</Text>
              }
            >
              <VChart
                key="sales-kpi"
                spec={poolLeadStatusSpec}
                options={{ mode: "desktop-browser" }}
                height={300}
              />

            </Card>
          </Col>
        </Row> */}

      </div>
    </>
  );
}
